export type NestedItem = {
  name: string;
  path: string;
  Container?: any;
  children?: NestedItem[];
}

const createNestedListFromStringList = (stringList: string[]) => {
  const itemsWithChildren: NestedItem[] = [];

  stringList.forEach(item => {
    const stringArr = item.split('/');
    let currentDeepLevel = itemsWithChildren;
    let path = '';
    stringArr.forEach((str, index) => {
      path = `${path}/${str}`;
      let currentItem = currentDeepLevel.find(({ name }) => name === str);

      if (!currentItem) {
        currentItem = { path, name: str };
        if (index + 1 !== stringArr.length) {
          currentItem.children = [];
        }
        currentDeepLevel.push(currentItem);
      } else if (!currentItem.children) {
        currentItem.children = [];
      }

      if (currentItem.children) currentDeepLevel = currentItem.children;
    });
  });

  return itemsWithChildren;
};

export default createNestedListFromStringList;
